import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { getTransactionPostings } from '../query-api'
import { TransactionPostingsData } from '../types/transactionPostingsData'

const selectSortedPostings = (data: TransactionPostingsData) =>
  [...data.postings].sort((a, b) => a.priority - b.priority)

export const useGetTransactionPostings = (transactionId?: string) => {
  const { data, isLoading } = useQuery(
    [QueryKeys.Transaction, transactionId, 'postings'],
    () => getTransactionPostings(transactionId as string),
    { enabled: !!transactionId, select: selectSortedPostings },
  )

  return { postings: data, isLoading }
}
